import React from "react";
import { useTranslation } from "react-i18next";
import IntroSection from "../components/IntroSection";
import IntroImg from "../assets/Intro-img.png";
import MainLayouts from "../layouts/MainLayouts";
import AboutSection from "../components/AboutSection";
import Events from "../components/Events";
import Education from "../components/Education/Education";
import News from "../components/News";
import Contact from "../components/Contact";
import PartnersSection from "../components/PartnersSection";

export default function Home() {
    const { t } = useTranslation();

    return (
        <MainLayouts pageTitle={t("home.pageTitle")}>
            <h1 className="font-geologica text-[36px] font-medium leading-[100%] uppercase text-primary-400">
                    {t("home.pageTitle")}
                </h1>
            <div className="flex flex-col gap-[80px] md:gap-[90px] lg:gap-[100px] lg:pb-[80px] pb-[90px]">
                <IntroSection
                    titleKey="home.subtitle"
                    descriptionKey="home.description"
                    imgSrc={IntroImg}
                    buttonTextKey="buttons.learnMore"
                />

                <AboutSection />
                <Events />
                <Education />
                <PartnersSection />
                <News />
            </div>
        </MainLayouts>
    );
}
